import type { FaireCollectionEntity } from "../../entity_types/collection";

export const col_previously_ordered: FaireCollectionEntity = {
  token: "col_previously-ordered",
  type: "collection",
  name: "Previously Ordered",
  description: "Products you have ordered before.",
  thumbnailUrl:
    "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&h=400&fit=crop",
  season: "special",
  itemCount: 12,
  isSpecial: true,
  brandToken: "catalog_brand_audreys_home_gift",
  productTokens: [],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
